class ConfirmDialog {
  constructor({ dialogTitle, bodyText, closeButtonText, trueButtonText, falseButtonText, parent }) {
    this.dialogTitle = dialogTitle || "Title";
    this.bodyText = bodyText || "Are you sure?";
    this.closeButtonText = closeButtonText || "Close";
    this.trueButtonText = trueButtonText || "Yes";
    this.falseButtonText = falseButtonText || "Cancel";
    this.parent = parent || document.body;

    this.dialog = undefined;
    this.trueButton = undefined;
    this.falseButton = undefined;
    this.closeeButton = undefined;

    this._createDialog();
    this._appendDialog();
  }

  confirm() {
    return new Promise((resolve, reject) => {
      const somethingWentWrongUponCreation =
        !this.dialog || !this.trueButton || !this.falseButton || !this.closeButton;
      if (somethingWentWrongUponCreation) {
        reject('Someting went wrong when creating the modal');
        return;
      }
      
      this.dialog.showModal();
      this.trueButton.focus();

      this.trueButton.addEventListener("click", () => {
        resolve(true);
        this._destroy();
      });

      this.falseButton.addEventListener("click", () => {
        resolve(false);
        this._destroy();
      });

      this.closeButton.addEventListener("click", () => {
        resolve(false);
        this._destroy();
      });
    });
  }

  _createDialog() {
    this.dialog = document.createElement("dialog");
    this.dialog.classList.add("confirm-dialog");

    const dialogHeader = document.createElement("div");
    dialogHeader.classList.add("confirm-dialog__header");
    this.dialog.appendChild(dialogHeader);

    const dialogTitle = document.createElement("h2");
    dialogTitle.textContent = this.dialogTitle;
    dialogTitle.classList.add("confirm-dialog__title");
    dialogHeader.appendChild(dialogTitle);
      
    this.closeButton = document.createElement("button");
    this.closeButton.classList.add(
      "button",
      "button--icon",
      "button--close",
      "confirm-dialog__button"
    );

    this.closeButton.type = "button";
    this.closeButton.textContent = this.closeButtonText;
    dialogHeader.appendChild(this.closeButton);

    const dialogBody = document.createElement("div");
    dialogBody.innerHTML = this.bodyText;
    dialogBody.classList.add("confirm-dialog__body");
    this.dialog.appendChild(dialogBody);

    const buttonGroup = document.createElement("div");
    buttonGroup.classList.add("confirm-dialog__footer");
    this.dialog.appendChild(buttonGroup);

    this.falseButton = document.createElement("button");
    this.falseButton.classList.add(
      "button",
      "confirm-dialog__button",
      "button--false"
    );
    this.falseButton.type = "button";
    this.falseButton.textContent = this.falseButtonText;
    buttonGroup.appendChild(this.falseButton);

    this.trueButton = document.createElement("button");
    this.trueButton.classList.add(
      "button",
      "button--primary",
      "confirm-dialog__button",
      "button--true"
    );
    this.trueButton.type = "button";
    this.trueButton.textContent = this.trueButtonText;
    buttonGroup.appendChild(this.trueButton);
  }

  _appendDialog() {
    this.parent.appendChild(this.dialog);
  }

  _destroy() {
    this.parent.removeChild(this.dialog);
    delete this;
  }
}
